import React from "react";
import { useProductBranding } from "store/selectors/branding";

interface LoginWorkflowLayoutProps {
    title: string;
    subtitle?: string;
    children: React.ReactNode;
}

export const LoginWorkflowLayout: React.FC<LoginWorkflowLayoutProps> = ({
    title,
    subtitle,
    children,
}) => {
    return (
        <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <div className="flex justify-center mb-4">
                    <ProductLogo />
                </div>
                <h2 className="mt-8 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
                    {title}
                </h2>
                {subtitle && (
                    <p className="mt-2 text-center text-sm text-gray-600">{subtitle}</p>
                )}
            </div>

            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
                <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
                    {children}
                </div>
            </div>
        </div>
    );
};

const ProductLogo: React.FC = () => {
    const branding = useProductBranding();
    if (branding.isLoading) {
        return null;
    }
    if (!branding.branding) {
        return null;
    }
    if (!branding.branding.logoUrl) {
        return null;
    }
    return <img src={branding.branding.logoUrl} alt="Logo" className="h-20" />;
};
